import React, { Fragment, useState } from 'react';
import { FaEdit, FaEye, FaTrash } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { TD } from 'styled/table';
import checkPermission from 'utils/checkPermission';
import permissions from 'utils/permissionConstants';
import DeleteAlignmentCenter from './deleteAlignmentCenter';
import EditAlignmentCenter from './EditAlignmentCenter';

const ViewList = ({ alignmentCenter, index }) => {
  const [showViewModel, setShowViewModel] = useState(false);
  const [showEditModel, setShowEditModel] = useState(false);
  const [showDeleteModel, setShowDeleteModel] = useState(false);
  const currentUser = useSelector((state) => state.user.currentUser);
  return (
    <Fragment>
      <tr
        key={alignmentCenter._id}
        className={`${index % 2 !== 0 && 'bg-gray-100'}`}
      >
        <TD>{index + 1}</TD>
        <TD>{alignmentCenter.name}</TD>
        <TD>
          {alignmentCenter.createdAt
            ? new Date(alignmentCenter.createdAt).toLocaleDateString("en-GB").replace(/\//g, '-')
            : ''}
        </TD>
        <TD>
          {alignmentCenter.createdBy ?? "---"}
        </TD>
        <TD>
          {checkPermission([permissions.manage_masters], currentUser) ? (
            <div className="">
              <button
                onClick={() => setShowEditModel(true)}
                className="p-2 m-1  rounded-md bg-green-500 hover:bg-green-600 text-white"
              >
                <FaEdit />
              </button>
              <button
                onClick={() => setShowViewModel(true)}
                className="p-2 m-1 rounded-md bg-yellow-500 hover:bg-yellow-600 text-white"
              >
                <FaEye />
              </button>
              <button
                disabled={alignmentCenter.blocked}
                onClick={() => setShowDeleteModel(true)}
                className={`p-2  m-1 rounded-md  ${alignmentCenter.blocked ? "bg-gray-400" : "bg-red-500 hover:bg-red-600"} text-white`}
              >
                <FaTrash />
              </button>
            </div>
          ) : (
            <p>----</p>
          )}
        </TD>
      </tr>
      {showViewModel && (
        <EditAlignmentCenter
          data={alignmentCenter}
          desable={true}
          handleClick={() => setShowViewModel(false)}
        />
      )}
      {showEditModel && (
        <EditAlignmentCenter
          data={alignmentCenter}
          handleClick={() => setShowEditModel(false)}
        />
      )}

      {showDeleteModel && (
        <DeleteAlignmentCenter
          id={alignmentCenter._id}
          handleClick={() => setShowDeleteModel(false)}
        />
      )}
    </Fragment>
  );
};

export default ViewList;
